<template>
    <div id="snowflakeConn">
        <b-input-group size="md" prepend="Account">
            <b-input type="account" v-model="connection.token" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
        <b-input-group size="md" prepend="User">
            <b-input type="user" v-model="connection.user" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
        <b-input-group size="md" prepend="Authenticator">
            <b-input type="authenticator" v-model="connection.authenticator" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
        <b-input-group size="md" prepend="Role">
            <b-input type="role" v-model="connection.role" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
        <b-input-group size="md" prepend="Warehouse">
            <b-input type="warehouse" v-model="connection.warehouse" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
        <b-input-group size="md" prepend="Database">
            <b-input type="database" v-model="connection.database" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
        <b-input-group size="md" prepend="Schema">
            <b-input type="schema" v-model="connection.schema" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
    </div>
</template>

<script>
// components

// server

// modules

export default {
  name: "snowflake-conn",

  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
    };
  },

  computed: {

  },

  methods: {

    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
      
    },

  }
};
</script>


<style scoped lange="css">

</style>


// WEBPACK FOOTER //
// src/components/connection/SnowflakeConnection.vue